/**
 * Resolves once the page's `load` event has fired, so work that the first
 * paint does not need (auth checks, analytics) stays off the critical path.
 */
export function pageLoaded(): Promise<void> {
  if (document.readyState === "complete") return Promise.resolve();
  return new Promise((resolve) => {
    window.addEventListener("load", () => resolve(), { once: true });
  });
}
